import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4c74e53d&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=4c74e53d&prod&lang=scss&scoped=true"
import style1 from "./scss/pc.scss?vue&type=style&index=1&id=4c74e53d&prod&lang=scss&scoped=true&external"
import style2 from "./App.vue?vue&type=style&index=2&id=4c74e53d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74e53d",
  null
  
)

export default component.exports